const expensesTable = {
  columns: {
    getColumnsData: 'expensesColumnsData',
    setColumnsData: 'setExpensesColumnsData'
  },
  rows: {
    getRowsData: 'expensesRowsData',
    setRowsData: 'setExpensesRowsData'
  }
}

const expensesTableColumns = [
  {
    id: 1,
    title: 'DATE OF PAYMENT',
    property: 'dateOfPayment',
    inputs: ['amountAED'],
    editable: true,
    type: 'date',
    typeEditable: 'datePicker',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 2,
    title: 'CATEGORY',
    inputs: ['amountAED'],
    property: 'category',
    editable: true,
    sortByColumn: true,
    typeEditable: 'select',
    listName: 'expensesCategory',
    list: [],
    categoryType: 1,
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 3,
    title: 'CATEGORY 2',
    inputs: ['amountAED'],
    property: 'secondCategory',
    defaultProperty: 'secondCategory',
    editable: true,
    sortByColumn: true,
    typeEditable: 'select',
    listName: 'expensesCategory',
    list: [],
    categoryType: 2,
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 4,
    title: 'PAYMENT DESCRIPTION',
    inputs: ['amountAED'],
    property: 'paymentDescription',
    regexp: /CN\/\d+\/BB-\d+./gmi,
    editable: true,
    type: 'link',
    typeEditable: 'inputString'
  },
  {
    id: 5,
    title: 'TYPE OF PAYMENT',
    inputs: ['amountAED'],
    property: 'typeOfPayment',
    editable: true,
    sortByColumn: true,
    typeEditable: 'select',
    listName: 'expensesCategory',
    list: [],
    categoryType: 3,
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 6,
    title: 'AMOUNT, AED',
    inputs: ['amountAED'],
    property: 'amountAED',
    editable: true,
    typeEditable: 'inputNumber',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 7,
    title: 'FUND',
    inputs: ['amountAED'],
    property: 'funds',
    editable: true,
    typeEditable: 'select',
    listName: 'fundList',
    list: [],
    placeholder: 'Fund',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 8,
    property: 'action',
    inputs: ['amountAED'],
    actions: {
      edit: true,
      delete: true
    },
    toolbar: {
      hideEditBtn: false,
      hideDeleteBtn: false,
      upload: true
    }
  }
]

export {expensesTable, expensesTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/expensesTable.js